import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import {
  AboutUs,
  ContactUs,
  Home,
  Portfolio,
  ProjectDetails,
  Industries,
} from './screens';
import { Footer, Header, Box, ScrollToTop } from './components';
import { COLORS, device } from './constants';
import styled from 'styled-components';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PortfolioProvider } from './context/PortfolioContext';

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <PortfolioProvider>
        <AppContainer>
          <Router>
            <ScrollToTop />
            <HeaderContainer>
              <Box>
                <Header />
              </Box>
            </HeaderContainer>
            <MainContainer>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/contact" element={<ContactUs />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/industries" element={<Industries />} />
                <Route
                  path="/project/:projectName"
                  element={<ProjectDetails />}
                />
              </Routes>
            </MainContainer>
            <FooterContainer>
              <Box>
                <Footer />
              </Box>
            </FooterContainer>
          </Router>
        </AppContainer>
      </PortfolioProvider>
    </QueryClientProvider>
  );
}

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  background-color: ${COLORS.WHITE};
`;

const MainContainer = styled.main`
  flex: 1 0 auto;
  overflow-y: auto;
  margin-top: 80px;
  min-height: 50vh;
  @media screen and (${device.md}) {
    margin-top: 60px;
  }
`;

const FooterContainer = styled.footer`
  background-color: ${COLORS.FOOTER_BACKGROUND};
`;

export default App;
